
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import { scrollWatcher } from '~/helpers/scroll-watcher.js';
import { homePageWatcher } from "~/helpers/is-main-page";

export default BaseCmsBlock.extend({
  name: "ArticlesBlock",

  fetch: async function () {
    await this.getArticlesApi();
  },

  data: function () {
    const cmsArticleTags = (this.values?.article_tags || []).map((t) => t?.value);
    const isCmsArticleTags = Boolean((cmsArticleTags || []).length);
    return {
      articlesApi: [],
      cmsArticleTags: cmsArticleTags || [],
      isApi: this.externalData?.ArticlesBlock?.isApi || isCmsArticleTags || false,
      isAnimate: false,
    }
  },

  mounted: function () {
    document.addEventListener('scroll', this.inFieldOfView);
  },

  unMounted: function () {
    document.removeEventListener('scroll', this.inFieldOfView);
  },

  computed: {
    articlesList: function () {
      if (this.isApi) {
        return this.articlesApi.slice(0, 3)
      }
      return this.extras?.articles.slice(0, 3) || []
    },
    tagsVisibleCards: function () {
      return this.externalData?.ArticlesBlock?.tagsVisibleCards || []
    },
    isHome: function () {
      return homePageWatcher(this.$route.fullPath)
    }
  },
  methods: {
    getArticlesApi: async function () {
      if (!this.isApi && !this.externalData?.ArticlesBlock?.isApi) {
        return
      }

      const tags = this.externalData?.ArticlesBlock?.tags || this.cmsArticleTags || [];
      if (!tags.length) {
        return
      }

      const exceptions = this.externalData?.ArticlesBlock?.exceptions || [];

      let filter = [];
      tags.map((tag) => {
        filter.push(`filter[tag_id][]=${tag}`);
      })
      let articles = await this.$api.agent.transport.get(`/articles?${filter.join('&')}&expand=tags`).then((res) => {
        return res.data
      }).catch((err) => {
        return []
      });
      articles = articles.filter((t) => !exceptions.includes(t.id))
      this.articlesApi = articles;
    },
    publishFrom: function (item) {
      return new Date(item?.publish_from * 1000).toLocaleDateString("ru", {
        day: '2-digit',
        month: "2-digit",
        year: 'numeric'
      })
    },
    inFieldOfView: function () {
      if (scrollWatcher('new-articles-block')) {
        document.removeEventListener('scroll', this.inFieldOfView);
        this.isAnimate = true;
      }
    },
  }
})
